// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","headerImage":"Header_headerImage__98I0z","headerBannerLoadingSkeleton":"Header_headerBannerLoadingSkeleton__reJWR","loading":"Header_loading__+oFkk"};